module.exports = __webpack_public_path__ + "static/media/6-iveco.9b362541.jpg";